import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "Components/Pages/Home";
import Commercial from "Components/Pages/Commercial";
import Film from "Components/Pages/Film";
import MusicVideo from "Components/Pages/MusicVideo";
import Photography from "Components/Pages/Photography";
import ImageSliderWithVideo from "Components/ImageSliderWithVideo/ImageSliderWithVideo";
import { projectSetups } from "./config";
import "./App.css";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />

        {/* Commercial routes */}
        <Route path="/commercial" element={<Commercial />} />
        {projectSetups.commercialProjects.projects?.map((project) => (
          <Route
            key={project.key}
            path={`/commercial/${project.key}`}
            element={<ImageSliderWithVideo collectionKey={project.key} />}
          />
        ))}

        {/* Film routes */}
        <Route path="/film" element={<Film />} />
        {projectSetups.filmProjects.projects?.map((project) => (
          <Route
            key={project.key}
            path={`/film/${project.key}`}
            element={<ImageSliderWithVideo collectionKey={project.key} />}
          />
        ))}

        {/* Music Video routes */}
        <Route path="/music-video" element={<MusicVideo />} />
        {projectSetups.musicVideoProjects.projects?.map((project) => (
          <Route
            key={project.key}
            path={`/music-video/${project.key}`}
            element={<ImageSliderWithVideo collectionKey={project.key} />}
          />
        ))}

        <Route path="/photography" element={<Photography />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
